const ScreeningReportModalCopyEnum = {
  REPORT_REQUESTED: 'REPORT_REQUESTED',
  PULLING_REPORT: 'PULLING_REPORT',
  TRANSUNION_ERROR: 'TRANSUNION_ERROR',
  GENERAL_ERROR: 'GENERAL_ERROR',
  REQUEST_MAILING_ADDRESS: 'REQUEST_MAILING_ADDRESS',
};

export default ScreeningReportModalCopyEnum;
